import { takeEvery, call, put } from "redux-saga/effects";
import {
  SETTINGS_EMAIL_DELETE_REQUEST,
  settingsEmailDeleted,
  settingsEmailDeleteError,
} from "../../actions/global-settings";
import deleteEmail from "../../../../../backend/oncall/partners/contact-details/emails/remove";

const requestDeleteEmail = function*(action) {
  try {
    yield call(deleteEmail, action.payload.email);
    yield put(settingsEmailDeleted(action.payload.email));
  } catch (ignore) {
    yield put(settingsEmailDeleteError(action.payload.email));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(SETTINGS_EMAIL_DELETE_REQUEST, requestDeleteEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/global-settings/request-delete-email.js